module.exports = __webpack_public_path__ + "static/media/Chat-smile.86d22a12.svg";